import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";

type TUseBackRedirectParams = {
  projectId: string;
  isActive: boolean;
  storageKey: string;
  onBack?: () => void;
  returnUrl?: string;
};

export function useBackRedirectFromProjectList({
  projectId,
  isActive,
  storageKey,
  onBack,
  returnUrl
}: TUseBackRedirectParams) {
  const navigate = useNavigate();
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useEffect(() => {
    if (!projectId) return;

    if (isActive) {
      const url = returnUrl ?? window.location.pathname + window.location.search;
      sessionStorage.setItem(storageKey, url);
    } else {
      sessionStorage.removeItem(storageKey);
    }

    const handlePopState = () => {
      const storedUrl = sessionStorage.getItem(storageKey);
      if (!storedUrl) return;

      if (window.location.pathname === getRouteProjects()) {
        sessionStorage.removeItem(storageKey);
        onBackRef.current?.();
        navigate(storedUrl, { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
      if (!isActive) sessionStorage.removeItem(storageKey);
    };
  }, [projectId, isActive, storageKey, returnUrl, navigate]);
}
